import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'

export const initialState = {

  fetching: false,
  componentKey: getComponentKey(),

  year: null,

  updatingHolidays: false,

  creating: false,
  createdYearResponse: null
}

export const actionTypes = {

  ReportingYearFetching: 'reportingYear/fetching',
  ReportingYearFetched: 'reportingYear/fetched',

  ReportingYearUpdatingHolidays: 'reportingYear/updatingHolidays',
  ReportingYearUpdatedHolidays: 'reportingYear/updatedHolidays',

  ReportingYearCreating: 'reportingYear/creating',
  ReportingYearCreated: 'reportingYear/created',
  ReportingYearClearCreatedResponse: 'reportingYear/clearCreatedResponse',
  Error: 'reportingYear/error'
}

export const actionCreators = {

  getByYear: (id) => (dispatch) => {
    dispatch({ type: actionTypes.ReportingYearFetching })
    context.api.reportingYearService.getByYear(id)
      .then(response => {
        dispatch({ type: actionTypes.ReportingYearFetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },

  updateHolidays: (input) => (dispatch) => {
    dispatch({ type: actionTypes.ReportingYearUpdatingHolidays })
    context.api.reportingYearService.updateHolidays(input)
      .then(response => {
        dispatch({ type: actionTypes.ReportingYearUpdatedHolidays })
        dispatch(actionCreators.getByYear(input.number))
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },

  createYear: (number) => (dispatch) => {
    dispatch({ type: actionTypes.ReportingYearCreating })
    context.api.reportingYearService.createYear({ number })
      .then(response => {
        dispatch({ type: actionTypes.ReportingYearCreated, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },

  clearCreateYearResponse: () => (dispatch) => {
    dispatch({ type: actionTypes.ReportingYearClearCreatedResponse })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ReportingYearFetching: return { ...state, fetching: true }
    case actionTypes.ReportingYearFetched: return { ...state, fetching: false, componentKey: getComponentKey(), year: action.data }
    case actionTypes.ReportingYearUpdatingHolidays: return { ...state, updatingHolidays: true }
    case actionTypes.ReportingYearUpdatedHolidays: return { ...state, updatingHolidays: false, componentKey: getComponentKey() }
    case actionTypes.ReportingYearCreating: return { ...state, creating: true }
    case actionTypes.ReportingYearCreated: return { ...state, creating: false, createdYearResponse: action.data }
    case actionTypes.ReportingYearClearCreatedResponse: return { ...state, createdYearResponse: null }
    case actionTypes.Error: return { ...state, fetching: false, updatingHolidays: false, creating: false }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportingYear.js